
const SIGN_UP_LOCALE_TEMPLATES = {
    "en": {
        //Professional
        "sign.up.professional.title": "Sign up",
        "sign.up.professional.subtitle": "Sign up for free to find your dream job",
        "sign.up.professional.first.name": "First name",
        "sign.up.professional.last.name": "Last name",
        "sign.up.professional.personal.information.step.button.label": "Next",
        "sign.up.professional.separator": "or",
        "sign.up.professional.route.to.company.page.button": "Click here",
        "sign.up.professional.route.to.company.page.label": "if you’re looking for top talent for your company!",
        "sign.up.professional.route.to.company.page.label.mobile": "if you’re looking for <br/> top talent for your company!",
        "sign.up.professional.email.type": "Personal",
        "sign.up.professional.email": "email address",
        "sign.up.professional.password": "Password",
        "sign.up.professional.password.separator": "Note: at least 12 characters",
        "sign.up.professional.repeat.password": "Repeat password",
        "sign.up.professional.button": "Sign up",
        "sign.up.facebook.no.email.error.message": "We cannot determine your email from your Facebook profile. Please sign up using an email address",


        //Company
        "sign.up.company.title": "Start searching",
        "sign.up.company.subtitle": "Sign up for free to find talent for your company",
        "sign.up.company.first.name": "First name",
        "sign.up.company.last.name": "Last name",
        "sign.up.company.personal.information.step.button.label": "Next",
        "sign.up.company.separator": "or",
        "sign.up.company.note": "Note: use your company account",
        "sign.up.company.route.to.professional.page.button": "Click here",
        "sign.up.company.route.to.professional.page.label": "if you're looking for a dream job for yourself!",
        "sign.up.company.route.to.professional.page.label.mobile": "if you're looking for <br/> a dream job for yourself!",
        "sign.up.company.email.type": "Business",
        "sign.up.company.email": "email address",
        "sign.up.company.password": "Password",
        "sign.up.company.password.separator": "Note: at least 12 characters",
        "sign.up.company.repeat.password": "Repeat password",
        "sign.up.company.button": "Sign up",

        //Common
        "sign.up.popups.password.mismatch": "Passwords do not match",
        "sign.up.popups.signed.up": "Signed up!",
        "sign.up.popups.password.minimum.characters": "Password must be at least 12 characters long"
    },
    "nl": {
        //Professional
        "sign.up.professional.title": "Inschrijven",
        "sign.up.professional.subtitle": "Meld je gratis aan om je droombaan te vinden",
        "sign.up.professional.first.name": "Voornaam",
        "sign.up.professional.last.name": "Achternaam",
        "sign.up.professional.personal.information.step.button.label": "Volgende",
        "sign.up.professional.separator": "of",
        "sign.up.professional.route.to.company.page.button": "Klik hier",
        "sign.up.professional.route.to.company.page.label": "als je op zoek bent naar toptalent voor je bedrijf!",
        "sign.up.professional.route.to.company.page.label.mobile": "als je op zoek bent <br/> naar toptalent voor je bedrijf!",
        "sign.up.professional.email.type": "Persoonlijk",
        "sign.up.professional.email": "emailadres",
        "sign.up.professional.password": "Wachtwoord",
        "sign.up.professional.password.separator": "Let op: minimaal 12 tekens",
        "sign.up.professional.repeat.password": "Herhaal wachtwoord",
        "sign.up.professional.button": "Inschrijven",
        "sign.up.facebook.no.email.error.message": "We kunnen je e-mailadres niet achterhalen via je Facebook-profiel. Meld je aan met een e-mailadres",

        //Company
        "sign.up.company.title": "Start met zoeken",
        "sign.up.company.subtitle": "Meld je gratis aan om talent te vinden voor jouw bedrijf",
        "sign.up.company.first.name": "Voornaam",
        "sign.up.company.last.name": "Achternaam",
        "sign.up.company.personal.information.step.button.label": "Volgende",
        "sign.up.company.separator": "of",
        "sign.up.company.note": "Let op: gebruik je company account",
        "sign.up.company.route.to.professional.page.button": "Klik hier",
        "sign.up.company.route.to.professional.page.label": "als je op zoek bent naar een droombaan voor jezelf!",
        "sign.up.company.route.to.professional.page.label.mobile": "als je op zoek bent <br/> naar een droombaan voor jezelf!",
        "sign.up.company.email.type": "Zakelijk",
        "sign.up.company.email": "emailadres",
        "sign.up.company.password": "Wachtwoord",
        "sign.up.company.password.separator": "Let op: minimaal 12 tekens",
        "sign.up.company.repeat.password": "Herhaal wachtwoord",
        "sign.up.company.button": "Inschrijven",

        //Common
        "sign.up.popups.password.mismatch": "Wachtwoorden komen niet overeen",
        "sign.up.popups.signed.up": "Inschrijving gelukt!",
        "sign.up.popups.password.minimum.characters": "Wachtwoord moet minimaal 12 tekens lang zijn"
    }
}

export default SIGN_UP_LOCALE_TEMPLATES;